// extracted by mini-css-extract-plugin
export var wordContainer = "_or-0";